import styled from 'styled-components'

import crossIcon from 'assets/images/femi-cross.svg'

import { Color } from 'root-constants'

import { FemiFlowColor } from '../../constants'
import { FlowDescription, FlowTitle } from '../../styles'

export const StyledFlowCancelConfirmation = {
  Title: styled(FlowTitle)`
    margin-bottom: 16px;
    font-weight: 500;
  `,
  Description: styled(FlowDescription)`
    margin-bottom: 24px;
  `,
  Losses: styled.ul`
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 29px;
  `,
  Loss: styled.li`
    display: flex;
    gap: 12px;
    color: ${Color.BLACK};
    font-size: 17px;
    font-weight: 400;
    line-height: 26px;

    &::before {
      content: '';
      flex-shrink: 0;
      width: 24px;
      height: 24px;
      margin-top: 1px;
      border-radius: 50%;
      background-color: ${FemiFlowColor.PINK_LIGHT};
      background-image: url(${crossIcon});
      background-position: center;
      background-repeat: no-repeat;
    }
  `,
  Buttons: styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
  `,
}
